import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { IMenu } from '@core/models/interfaces/menu.interface';
@Component({
  selector: 'app-menu-desktop',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  templateUrl: './menu-desktop.component.html',
  styleUrls: ['./menu-desktop.component.scss'],
})
export class MenuDesktopComponent {
  @Input() menu: IMenu[] = [];

  faChevronDown = faChevronDown;

  constructor(private router: Router) {}

  redirectTo(item: IMenu) {
    this.router.navigate([`${item.url}`]);
  }
}
